import React from 'react';
import {useLoaderData, useLocation} from '@remix-run/react';

//components
import {Link} from 'components/Link';

//domains
import {findNestedLevel, findParents, gidExists} from 'domains/collections';
import {loader} from '~/routes/($lang)/collections/$collectionHandle';
export default function BrandBreadcrumb() {
  const {search} = useLocation();
  const params = new URLSearchParams(search);
  const requestedVendor = params.get('pf_v_brand');
  const {translation} = useLoaderData<typeof loader>();

  return (
    <div className="z-10 w-screen bg-white lg:relative lg:left-0 lg:w-full lg:translate-x-0">
      <div className="px-5 lg:px-0">
        <nav className="text-sm md:text-mdflex flex-wrap items-center lg:mb-[34px]">
          <Link
            to="/"
            className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
          >
            {translation.home ?? 'Home'}
          </Link>
          <span className="mx-2 inline-block font-light">/</span>
          <Link
            to="/pages/brands"
            className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
          >
            {translation?.all_brands ?? 'All Brands'}
          </Link>
          <span className="mx-2 inline-block font-light">/</span>
          <span className="font-light uppercase">{requestedVendor}</span>
        </nav>
      </div>
      <div className="lg:col-span-6"></div>
    </div>
  );
}
